import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as JspUtil from '../common/JspUtil';
import * as errorCodes from '../common/errorCodes';
import submitHiddenForm from '../common/submitHiddenForm';
import { IceIcon, PageContainer, TextInput } from '../components';
import { useJspVariables, useAppContext, useDebugRender } from '../hooks';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
const PageSamlTfa = () => {
    useDebugRender('PageSamlTfa');
    const location = useLocation();
    const { launcher, panelStyle, jspVariables } = useJspVariables();
    const { getLabelFromJspVariables } = useAppContext(jspVariables);

    const [pageMessage] = useState(() => {
        return location?.state?.pageMessage || '';
    });
    const [samlMessage, setSamlMessage] = useState('');
    const [relayState, setRelayState] = useState('');
    const [otpCode, setOtpCode] = useState('');
    const [alert, setAlert] = useState(null);
    const [errors, setErrors] = useState({});
    const [samlResponse] = useState(() => {
        return JspUtil.isValueAvailable(window.jspSAMLResponse) ? window.jspSAMLResponse : '';
    });

    useEffect(() => {
        if (JspUtil.isValueAvailable(window.jspSamlMessage)) {
            setSamlMessage(window.jspSamlMessage);
        }
        if (JspUtil.isValueAvailable(window.jspSamlRelayState)) {
            setRelayState(window.jspSamlRelayState);
        }
    }, []);

    const onLoginClick = () => {
        setAlert(null);
        if (!otpCode.trim()) {
            setErrors({ otpCode: errorCodes.MSG_FIELD_REQUIRED() });
            return;
        }
        setErrors({});
        submitHiddenForm('/samlauth', {
            SAMLResponse: samlResponse,
            RelayState: relayState,
            otpCode,
        });
    };

    return (
        <PageContainer id="pageSamlMessage" dataAutomationId="page_saml_message">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                {alert && <Alert id="pageSamlTfaAlert" data-automation-id="page_saml_tfa_alert" severity={alert.severity} sx={{ mb: 1 }} onClose={() => setAlert(null)}>{alert.message}</Alert>}
                <Box>
                    <Typography fontWeight={500}>{getLabelFromJspVariables('title_login_requires_mfa')}</Typography>
                    {samlMessage && <Typography variant="body2">{samlMessage}</Typography>}
                    {pageMessage && <Typography variant="body2">{pageMessage}</Typography>}
                </Box>
                <TextInput
                    label={getLabelFromJspVariables('label_tfa_passcode')}
                    name="otpCode"
                    id="otp_code_input"
                    dataAutomationId="otp_code_input"
                    autoComplete="one-time-code"
                    required
                    numericOnly maxLength={6}
                    value={otpCode}
                    error={!!errors.otpCode}
                    helperText={errors.otpCode || ''}
                    onChange={e => { setOtpCode(e.target.value); if (errors.otpCode) setErrors({}); }}
                />
                <Button variant="contained" fullWidth
                    onClick={onLoginClick}
                    data-automation-id="saml_tfa_login_btn">
                    {getLabelFromJspVariables('action_login')}
                </Button>
            </Box>
        </PageContainer>
    );
};

export default PageSamlTfa;
